<template>
	<div>
		<section class="heading">
			<h1 class="title">{{ title }}</h1>
			<button @click="$router.back()" class="btn btn-link btn-lg btn-cancel" :disabled="isLoading">
				Back
			</button>
		</section>
		<form @submit="handleSubmit">
			<div class="row">
				<div class="col-sm-12">
					<div class="box box-primary">
						<div class="box-header with-border">Service Data</div>
						<div class="box-body">
							<input-wrapper id="name" label="Name">
								<input v-model="fields.name" id="name" type="text" class="form-control" :disabled="isLoading" required>
								<button 
									v-if="!hasServices" 
									v-show="!subserviceFormActive" 
									class="btn btn-link" 
									@click="activateSubserviceForm">
									Add subservice
								</button>
							</input-wrapper>

							<div v-if="!hasServices">
								<subservice-form 
									v-show="subserviceFormActive"
									:onItemsUpdate="onSubserviceUpdate"
									:initialItems="initialSubservices"
									:existingSubservices="availableSubservices"
								/>
							</div>

							<input-wrapper id="description" label="Description">
								<textarea id="description" v-model="fields.description" :disabled="isLoading" class="form-control"></textarea>
							</input-wrapper>
							<input-wrapper id="duration" label="Duration">
								<input v-model="fields.duration" id="duration" type="number" class="form-control" :disabled="isLoading" required>
							</input-wrapper>
							<input-wrapper id="price" label="Price" :warning="priceWarning">
								<money class="form-control" v-model="fields.price" v-bind="money"></money>
								<span class="help-block">
									Minimum price suggestion: {{ formatPrice(recommendedBasePrice) }}
								</span>
							</input-wrapper>
						</div>
					</div>
				</div>
				<div class="col-xs-12 text-right">
					<button class="btn btn-primary btn-lg" :disabled="isLoading">
						<i class="fa fa-circle-o-notch fa-spin" v-show="isLoading"></i>
						{{ submitTxt }}
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { defaultFields } from "./helpers";
import InputWrapper from "../InputWrapper.vue";
import { Money } from 'v-money';
import { moneyTemplate, formatPrice } from '../../helpers';
import SubserviceForm from './SubserviceForm.vue';

export default {
	components: {
		InputWrapper,
		Money,
		SubserviceForm,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		submitTxt: {
			type: String,
			required: true,
		},
		onSubmit: {
			type: Function,
			required: true,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		fields: {
			type: Object,
			default: defaultFields,
		},
		errors: {
			type: Object,
			default: defaultFields,
		},
		basePrice: {
			type: Number,
			default: 0,
		},
		initialSubservices: {
			type: Array,
			default: () => [],
		},
		onSubserviceUpdate: {
			type: Function,
			required: false,
		},
	},
	beforeMount() {
		this.fetchAvailableSubservices();
	},
	watch: {
		fields(value) {
			if (!!value.id && this.hasProperty('subservices', value)) {
				this.subserviceFormActive = true;
			}
		}
	},
	data() {
		return {
			money: moneyTemplate(),
			subserviceFormActive: false,
			availableSubservices: [],
		}
	},
	computed: {
		recommendedBasePrice() {
			const total = (this.basePrice * this.fields.duration) + this.subservicesPrice;
			return total;
		},
		subservicesPrice() {
			return this.fields.subservices.reduce((subtotal, item) => {
				return subtotal + item.price;
			}, 0);
		},
		priceWarning() {
			if (this.fields.price < this.recommendedBasePrice) {
				return 'Your pricing is below the recommended base price';
			}
			return null;
		},
		hasServices() {
			return this.hasProperty('services', this.fields);
		},
	},
	methods: {
		formatPrice,
		activateSubserviceForm(e) {
			e.preventDefault();
			this.subserviceFormActive = true;
		},
		hasProperty(needle, haystack) {
			if (typeof haystack[needle] === 'undefined') {
				return false;
			}

			return haystack[needle].length > 0;
		},
		async fetchAvailableSubservices() {
			try {
				const response = await axios.get('/services?subservice=1');
				this.availableSubservices = response.data.data;
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Subservices cannot be loaded!'
				})
			}
		},
		handleSubmit(e) {
			e.preventDefault(); 
			this.onSubmit(this.formatFields(this.fields)).then(response => {
				this.fetchAvailableSubservices();
			});
		},
		formatFields(fields) {
			return {
				...fields,
				price: fields.price || 0, // Little hack because of v-money
			}
		}
	}
}
</script>
